module.exports = __webpack_public_path__ + "media/images/static/top/urban/left_mobile-60221a5e551d28abed3fee87831c8078.png";